import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { Lock } from "lucide-react";
import { http } from "@/lib/api";

export default function CrmLogin() {
  const nav = useNavigate();
  const [email, setEmail] = useState("admin@nextshore.com");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const { data } = await http.post("/auth/login", { email, password });
      localStorage.setItem("ns_token", data.token);
      localStorage.setItem("ns_email", data.email);
      localStorage.setItem("ns_role", data.role || "staff");
      localStorage.setItem("ns_tier", data.tier || "ops");
      localStorage.setItem("ns_staff_role", data.staff_role || "");
      if (data.name) localStorage.setItem("ns_name", data.name);
      else localStorage.removeItem("ns_name");
      toast.success(`Welcome back, ${data.name || data.email}`);
      nav("/crm");
    } catch (err) {
      toast.error(err.response?.data?.detail || "Login failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div data-testid="crm-login-page" className="min-h-screen flex items-center justify-center px-4 stardust relative">
      <div className="relative z-10 w-full max-w-md glass-dark rounded-3xl p-10">
        <div className="flex items-center gap-3 mb-8">
          <img src="/logo.png" alt="NS-I" className="h-12 w-auto" />
          <span className="font-serif text-2xl font-bold">NS-I</span>
        </div>

        <h1 className="font-serif text-3xl mb-2">Sign in</h1>
        <p className="text-sm text-slate-400 mb-8">
          Restricted access — pre-approved emails only.
        </p>

        <form onSubmit={submit} className="space-y-4">
          <label className="block">
            <span className="text-xs uppercase tracking-widest text-slate-400">Email</span>
            <input
              data-testid="crm-login-email"
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              className="mt-1 w-full bg-[#162A4D]/60 border border-[#C9A961]/25 rounded-xl px-4 py-3 text-sm text-white focus:outline-none focus:border-[#C9A961]/70"
            />
          </label>
          <label className="block">
            <span className="text-xs uppercase tracking-widest text-slate-400">Password</span>
            <input
              data-testid="crm-login-password"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              className="mt-1 w-full bg-[#162A4D]/60 border border-[#C9A961]/25 rounded-xl px-4 py-3 text-sm text-white focus:outline-none focus:border-[#C9A961]/70"
            />
          </label>
          <button
            type="submit"
            disabled={loading}
            data-testid="crm-login-submit-btn"
            className="btn-gold w-full rounded-xl py-3 font-semibold flex items-center justify-center gap-2 disabled:opacity-60"
          >
            <Lock className="w-4 h-4" /> {loading ? "Signing in…" : "Sign in"}
          </button>
        </form>

        <p className="mt-6 text-[11px] text-slate-500 text-center">
          Staff: admin@nextshore.com / admin123 · Advisor: aisha.okoye@nextshore.com / advisor2026
        </p>
      </div>
    </div>
  );
}
